import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { ErrorService, isPausedAccess } from 'app/services/error.service';
import { LocalisationService } from 'app/services/localisation.service';
import { QuestionnaireService } from 'app/services/questionnaire.service';
import { LoadingProvider } from '@app/components/_shared/loading-spinner/loading-spinner.component';
import { AppConfig } from '@app/app.config';
var ErrorComponent = /** @class */ (function () {
    function ErrorComponent(router, questionnaireService, localisation, authService, errorService, spinner) {
        this.router = router;
        this.questionnaireService = questionnaireService;
        this.localisation = localisation;
        this.authService = authService;
        this.errorService = errorService;
        this.spinner = spinner;
        this.locale = {};
    }
    ErrorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.locale = this.localisation.getTranslationsForComponent('ErrorComponent');
        this.error = this.errorService.error
            ? this.errorService.error
            : { code: 0, title: this.locale.genericErrorHeader, message: this.locale.genericErrorText };
        if (this.error.code == 0) {
            this.questionnaireService.getQuestionnaireStatus().subscribe(function (statusResponse) {
                var res = statusResponse;
            }, function (error) {
                if (error.returnCode != null) {
                    switch (error.returnCode.label) {
                        case 'E_PAUSED_ACCESS':
                            _this.error = {
                                code: error.returnCode.label,
                                title: _this.locale.pauseHeader,
                                message: _this.locale.pauseText
                            };
                            return false;
                        case 'E_PAUSED_ACCESS_QUESTIONNAIRE':
                            _this.error = {
                                code: error.returnCode.label,
                                title: _this.locale.pauseHeader,
                                message: _this.locale.pauseQuestionnaireText
                            };
                            return false;
                        case 'E_MAINTENANCE_MODE':
                            _this.error = {
                                code: error.returnCode.label,
                                title: _this.locale.maintenanceModeHeader,
                                message: _this.locale.maintenanceModeText
                            };
                            return false;
                    }
                }
            });
        }
        this.spinner.hide();
    };
    Object.defineProperty(ErrorComponent.prototype, "isPaused", {
        get: function () {
            return isPausedAccess(this.error.code);
        },
        enumerable: true,
        configurable: true
    });
    ErrorComponent.prototype.goToMyFJ = function () {
        window.location.href = AppConfig.MyFJUrl;
    };
    ErrorComponent.prototype.back = function () {
        this.errorService.clear();
        window.history.go(-2);
    };
    ErrorComponent.prototype.logout = function () {
        this.errorService.clear();
        this.authService.logout();
        this.router.navigateByUrl('/login');
    };
    ErrorComponent.route = 'error';
    return ErrorComponent;
}());
export { ErrorComponent };



// WEBPACK FOOTER //
// ./src/app/components/_shared/error/error.component.ts.pre-build-optimizer.js